import { useEffect, useState } from "react";
import "./KKokkioWorldIcon.css";
import kkokkio_world from "../assets/img/kkokkio-world-icon.webp";
// Link 제거 - KkokkioWorld가 legacy로 이동하여 비활성화

function KkokkioWorldIcon({ color }) {
  const [animationCompleted, setAnimationCompleted] = useState(false);
  const textColor = color === "#FFFFFF" ? "#DE4C3C" : "#FFF"; // 흰색일 때는 오렌지, 그 외에는 흰색으로 설정

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationCompleted(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      className={`kkokkio-world-box ${animationCompleted ? "shrink" : ""}`} 
      style={{ backgroundColor: color, cursor: 'default' }}
    >
      <div className={`text ${animationCompleted ? "hide" : ""}`} style={{ color: textColor }}>
        친구들과 <b style={{ fontWeight: "800" }}>&nbsp;동물농장</b>
      </div>
      {animationCompleted && (
        <img
          src={kkokkio_world}
          width={'25px'}
          height={'25px'}
          alt="kkokkio_world"
          className={`earth-image ${animationCompleted ? "show" : ""}`}
        />
      )}
    </div>
  );
}

export default KkokkioWorldIcon;
